/**
 * <LevelBars> — un niveau sonore en barres (atom).
 *
 * Le micro qui entend, le son qui joue : au test du matériel, l'élève doit VOIR que quelque chose
 * bouge quand il dit « allô » ou quand la mélodie part. Des barres de hauteur croissante ; celles
 * que le niveau atteint s'allument à la couleur d'affichage de l'univers (jamais un texte), les
 * autres restent au contour.
 *
 * Contrôlé et immobile : le niveau (0 à 1) arrive en prop, l'écran le relit à son rythme (le micro
 * dix fois par seconde aujourd'hui). Rien ne s'anime ici.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

export type LevelBarsProps = {
    /** Le niveau, de 0 (rien) à 1 (toutes les barres). */
    level: number
    /** Le nombre de barres. Défaut 6, celui d'aujourd'hui. */
    count?: number
    /** Ce que le lecteur d'écran dit des barres. */
    accessibilityLabel?: string
    testID?: string
}

/** La barre la plus basse, puis le pas de l'une à l'autre : la plus haute fait 30, la hauteur d'aujourd'hui. */
const BAR = { width: 6, minHeight: 8, step: 4.4 }

export function LevelBars(props: LevelBarsProps) {
    const { level, count = 6, accessibilityLabel, testID } = props
    const lit = Math.round(Math.max(0, Math.min(1, level)) * count)

    return (
        <View
            style={styles.row}
            testID={testID}
            accessible={accessibilityLabel != null}
            accessibilityLabel={accessibilityLabel}
        >
            {Array.from({ length: count }, (_, index) => (
                <View key={index} style={styles.bar(BAR.minHeight + index * BAR.step, index < lit)} />
            ))}
        </View>
    )
}

const styles = StyleSheet.create((theme) => ({
    row: {
        flexDirection: "row",
        alignItems: "flex-end",
        gap: theme.spacing["1"],
    },
    bar: (height: number, lit: boolean) => ({
        width: BAR.width,
        height,
        borderRadius: theme.radius.full,
        backgroundColor: lit ? theme.colors.role : theme.colors.border,
    }),
}))
